import React from "react";
import { SignaturePad } from "../../../../components/ui";

/**
 * InspectorSignatureSection Component
 *
 * Provides signature pad and comments textarea for inspector review.
 *
 * @param {Object} props
 * @param {string} props.signature - Signature data URL
 * @param {string} props.comments - Inspector comments
 * @param {Function} props.onSignatureChange - Callback when signature changes
 * @param {Function} props.onCommentsChange - Callback when comments change
 */
const INSPECTOR_COMMENTS_MAX_LENGTH = 184;

const InspectorSignatureSection = ({
  signature,
  comments,
  onSignatureChange,
  onCommentsChange,
}) => {
  const currentLength = comments?.length || 0;
  const remainingChars = INSPECTOR_COMMENTS_MAX_LENGTH - currentLength;

  return (
    <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-6 mt-4 max-w-full overflow-hidden">
      <h2 className="text-xl font-bold text-gray-800 mb-4 border-b pb-2">
        Inspector Review
      </h2>

      {/* Comments Section */}
      <div className="mb-6">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Comments (Optional)
        </label>
        <textarea
          value={comments}
          onChange={onCommentsChange}
          placeholder="Add any comments or notes about this T&M report."
          className="w-full border border-gray-300 rounded-md p-3 min-h-[120px] focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-y"
          maxLength={INSPECTOR_COMMENTS_MAX_LENGTH}
        />
        <p className="text-xs text-gray-500 mt-1 text-right">
          {remainingChars} characters remaining
        </p>
      </div>

      {/* Signature Section */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Signature <span className="text-red-500">*</span>
        </label>
        <SignaturePad
          value={signature}
          onChange={onSignatureChange}
          height={156}
        />
        <p className="text-xs text-gray-500 mt-2">
          Please sign above to approve this T&M report. Your signature confirms
          that you have reviewed the report and agree with the work performed.
        </p>
      </div>
    </div>
  );
};

export default InspectorSignatureSection;
